import { EventStatus } from '@wix/events-types';
export const UPCOMING_EVENT_STATUSES = [EventStatus.SCHEDULED, EventStatus.STARTED];
export const PAST_EVENT_STATUSES = [EventStatus.ENDED, EventStatus.CANCELED];
export const WIX_FEE_RATE = 0.025;
//# sourceMappingURL=event.js.map